import { createSlice } from '@reduxjs/toolkit'


const initialState = {

}

export const controllerSlice = createSlice({
    name: 'controller',
    initialState,
    reducers: {


    }
})


// export const { } = controllerSlice.actions;
export default controllerSlice.reducer